import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import { Dashboard, ShoppingCart, Replay, Paid, Radar, Bolt, OnlinePrediction } from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import { useINavigation } from "../../hooks/useINavigation";
import { AppPages } from "../../../config/pages";
import TradingModeDisplay from "../TradingModeToggle";
import ProfileMenu from "../ProfileMenu";

const AppDrawer = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { navigateTo, getPageTitle } = useINavigation();

  const redirectTo = (page) => {
    navigateTo(page);
    if (drawerOpen) setDrawerOpen(false);
  };

  return (
    <>
      <AppBar sx={{ minHeight: 35, height: 35 }}>
        <Toolbar sx={{ minHeight: "35px !important", height: "35px !important", padding: "15px !important" }} disableGutters>
          <IconButton edge="start" color="inherit" aria-label="menu" onClick={() => setDrawerOpen(!drawerOpen)}>
            <MenuIcon />
          </IconButton>
          <Typography variant="subtitle1" sx={{ flexGrow: 1 }}>
            ITrade4You 
          </Typography>
          <TradingModeDisplay />
          <ProfileMenu />
        </Toolbar>
      </AppBar>

      <Drawer
        variant="permanent"
        anchor="left"
        open={drawerOpen}
        sx={{
          width: { md: drawerOpen ? 240 : 50, xs: drawerOpen ? 240 : 0 },
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: { md: drawerOpen ? 240 : 50, xs: drawerOpen ? 240 : 0 },
            transition: "width 0.3s",
            position: "fixed",
            top: 35,
            left: 0,
            bottom: 0,
          },
        }}
      >
        <List>
          <Tooltip title="Dashboard" placement="right">
            <ListItem button onClick={() => redirectTo(AppPages.Dashboard)}>
              <ListItemIcon><Dashboard /></ListItemIcon>
              {drawerOpen && <ListItemText primary="Dashboard" />}
            </ListItem>
          </Tooltip>
          <Tooltip title="Buy Engine" placement="right">
            <ListItem button onClick={() => redirectTo(AppPages.Trading)}>
              <ListItemIcon><ShoppingCart /></ListItemIcon>
              {drawerOpen && <ListItemText primary="Buy Engine" />}
            </ListItem>
          </Tooltip>
          <Tooltip title="Momentum Trading" placement="right">
            <ListItem button onClick={() => redirectTo(AppPages.MomentumTrading)}>
              <ListItemIcon><Bolt /></ListItemIcon>
              {drawerOpen && <ListItemText primary="Momentum Trading" />}
            </ListItem>
          </Tooltip>
          <Tooltip title="Sale Engine" placement="right">
            <ListItem button onClick={() => redirectTo(AppPages.SaleEngine)}>
              <ListItemIcon><Paid /></ListItemIcon>
              {drawerOpen && <ListItemText primary="Sale Engine" />}
            </ListItem>
          </Tooltip>
          <Tooltip title="Live Prediction" placement="right">
            <ListItem button onClick={() => redirectTo(AppPages.LivePrediction)}>
              <ListItemIcon><OnlinePrediction /></ListItemIcon>
              {drawerOpen && <ListItemText primary="Live Prediction" />}
            </ListItem>
          </Tooltip>
          <Tooltip title="Screening" placement="right">
            <ListItem button onClick={() => redirectTo(AppPages.Screening)}>
              <ListItemIcon><Radar /></ListItemIcon>
              {drawerOpen && <ListItemText primary="Screening" />}
            </ListItem>
          </Tooltip>
          <Tooltip title="Back Testing" placement="right">
            <ListItem button onClick={() => redirectTo(AppPages.BackTesting)}>
              <ListItemIcon><Replay /></ListItemIcon>
              {drawerOpen && <ListItemText primary="Back Testing" />}
            </ListItem>
          </Tooltip>
        </List>
      </Drawer>
    </>
  );
};

export default AppDrawer;
